module.exports = __webpack_public_path__ + "static/media/your slippin-01.345d7342.png";